import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getOrderID, getOrderExpireDate } from 'Store/Order/selectors';
import { OrderPage } from 'Store/Order/enums';
import { fetchClearOrder, fetchOrderConfirmation } from 'Store/Order/thunks';
import OrderDeniedPage from 'Pages/OrderDeniedPage/OrderDeniedPage';
import { fetchCurrentUser } from 'Store/User/thunks';

interface IPropsInternal {
  orderID: number;
  orderExpireDate: Date;
  fetchClearOrder: () => void;
  fetchCurrentUser: () => void;
  fetchOrderConfirmation: () => void;
}

type Props = IPropsInternal  & RouteComponentProps<{ orderItemID: string }>;

class OrderDeniedPageContainer extends React.PureComponent<Props> {
  
  componentDidMount() {
    if (!this.props.orderID) {
      this.props.fetchOrderConfirmation();
    }
    this.props.fetchCurrentUser();
  }

  onTryAgain = () => { 
    const { history, match: { params: { orderItemID } } } = this.props;
    history.replace(`/order/${ orderItemID }${ OrderPage.DETAILS }`);
  }

  onCancel = () => {
    this.props.fetchClearOrder();
    this.props.history.replace('/');
  }

  render() {
    return (
      <OrderDeniedPage 
        orderID={ this.props.orderID }
        orderExpireDate={ this.props.orderExpireDate }
        onTryAgain={ this.onTryAgain }
        onCancel={ this.onCancel }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    orderID: getOrderID(state),
    orderExpireDate: getOrderExpireDate(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchClearOrder,
    fetchCurrentUser,
    fetchOrderConfirmation,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderDeniedPageContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderDeniedPage/OrderDeniedPageContainer.tsx